<template>
  <div class="course-wrapper">
    <div class="bread-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <i class="iconfont mr5">&#xe7eb;</i>
          <router-link to="/nlpCircle">NLP圈子</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>NLP课程</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <section>
      <div class="search-wrapper">
        <div class="course-type clearfix">
          <label class="search-label fl mr40">课程类别</label>
              <el-radio-group v-model="optionType" @change="handleTypeChange">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button v-for="(item,key,index) in typeData" :label="key" :key="index">{{item}}</el-radio-button>
              </el-radio-group>
        </div>
        <div class="line"></div>
        <div v-if="optionType!='nlp_gongan'" class="course-label clearfix">
          <label class="search-label fl mr40">课程标签</label>
         <el-radio-group v-model="optionLabel" @change="handleLabelChange" class="fl" style="width:1000px;">
          <el-radio-button label="">全部</el-radio-button>
                <el-radio-button v-for="(item,index) in labels" :label="item.id+''" :key="index">{{item.name}}</el-radio-button>
              </el-radio-group>
          <span class="btn-more" @click="toMore" v-if="upOrDown">展开
            <i class="iconfont">&#xe7f2;</i>
          </span>
          <span class="btn-more" @click="toMore" v-else>收起
            <i class="iconfont">&#xe786;</i>
          </span>
        </div>
        <div v-else class="course-label clearfix">
          <label class="search-label fl mr40">课程标签</label>
         <el-radio-group v-model="optionLabel" @change="handleLabelChange" class="fl" style="width:1000px;">
          <el-radio-button label="">全部</el-radio-button>
                <el-radio-button v-for="(item,index) in labels2" :label="item.id+''" :key="index">{{item.name}}</el-radio-button>
              </el-radio-group>
          <span class="btn-more" @click="toMore" v-if="upOrDown">展开
            <i class="iconfont">&#xe7f2;</i>
          </span>
          <span class="btn-more" @click="toMore" v-else>收起
            <i class="iconfont">&#xe786;</i>
          </span>
        </div>
        <div class="line"></div>
        <div class="course-filter clearfix">
          <label class="search-label fl mr40">排序</label>
          <div class="cell fl" :class="{active:orderActive==1 || orderActive==2 }" @click="byColligate()">综合
            <span class="caret-wrapper" >
              <i class="sort-caret ascending" :class="{active:orderActive==1}" ></i>
              <i class="sort-caret descending" :class="{active:orderActive==2}"></i>
            </span>
          </div>
          <div class="cell fl" :class="{active:orderActive==3 || orderActive==4 }" @click="byTime()">发布时间
            <span class="caret-wrapper">
              <i class="sort-caret ascending" :class="{active:orderActive==3}"></i>
              <i class="sort-caret descending" :class="{active:orderActive==4}"></i>
            </span>
          </div>
          <div class="cell fl" :class="{active:orderActive==5 || orderActive==6 }" @click="byHumanQi()">人气
            <span class="caret-wrapper">
              <i class="sort-caret ascending" :class="{active:orderActive==5}" ></i>
              <i class="sort-caret descending" :class="{active:orderActive==6}"></i>
            </span>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="course-list clearfix">
        <div class="course-item fl" v-for="(item,index) in dataList" :key="index">
          <div class="img-box"><router-link :to="{path:'/courseDetail',query:{id:item.id}}"><div class="mb15 img" :style="{backgroundImage:'url('+$api.getCoursePic+'courses_cover/'+item.id+')'}"></div></router-link></div>
          <p>
            <i class="iconfont">&#xe610;</i>
              <el-tooltip  v-if="item.courseName.length > 10" :content="item.courseName" placement="top" effect="light">
                <span>{{''+item.courseName.substring(0,10)}}... </span>
              </el-tooltip>
            <span v-else>{{item.courseName}}</span>

          </p>
          <p>
            <i class="iconfont">&#xe643;</i>
            <span class="color-blue">{{typeData[item.courseType]}}</span>
          </p>
          <p>
            <i class="iconfont">&#xe611;</i>
            <span>{{item.lecturer}} {{item.authorAffiliated}}</span>
          </p>
        </div>
      </div>
       <!-- 分页 -->
          <el-pagination v-if="total > 0" background class="mt20 tc" :page-size="pageSize" layout="prev, pager, next" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
          <div class="no-data" v-if="!dataList.length > 0">
            <img src="../../../assets/images/null-data.png" class="mt50 mb50"/>
            <p>该分类下暂无相关课程推荐，请您看看其他分类吧~</p>
            </div>
    </section>
    <cFooter></cFooter>
  </div>
</template>

<script>
export default {
  name: 'nlpCourse',
  components: {},
  metaInfo: {
    title:'NLP课程',
     meta: [
          { name: 'Keywords', content: '华霆数联,NLP课程'},
          { name:'Description', content:'NLP课程'},
    ]
  },
  data() {
    return {
      max: 1,
      pageNum: 1,
      pageSize: 12,
      total: 0,
      dataList: [],
      upOrDown: true,
      isIndeterminate: true,
      isIndeterminateLabel: true,
      checkAllType: false,
      checkedTypes: [],
      typeData: [], //课程类别
      checkAllLabel: false,
      checkedLabels: [],
      labels: [],
      labels2:[
        {
            createTime: "2021-09-06 10:33:24",
            id: 1067,
            isLeaf: 1,
            name: "pdf",
            parentId: 1001,
            status: 1,
            updateTime: "2021-09-06 10:33:27",
        },{
            createTime: "2021-09-06 10:33:48",
            id: 1068,
            isLeaf: 1,
            name: "视频",
            parentId: 1001,
            status: 1,
            updateTime: "2021-09-06 10:33:51",
        }
      ],
      labelData: [], //课程标签
      defaultLabels: [],
      colligate:false,
      time:false,
      humanQi:false,
      orderActive: 2,
      sortViewList: [
        {
          sortLevel: 1,
          sortName: 'sort_code',
          sortStyle: 'DESC',
        },
      ],
      optionType: '',
      optionLabel: '',
    };
  },
  mounted() {
    this.getData();
    this.getCourseType();
    this.getLabels();
  },
  methods: {
    handleCurrentChange() {},
    byColligate(){
      this.colligate=!this.colligate;
      let mark=this.colligate ? 1 : 2;
      this.toOrder(mark); 
    },
    byTime(){
       this.time=!this.time;
      let mark=this.time ? 3 : 4;
      this.toOrder(mark); 
    },
    byHumanQi(){
       this.humanQi=!this.humanQi;
      let mark=this.humanQi ? 5 : 6;
      this.toOrder(mark); 
    },
    toMore() {
      this.upOrDown = !this.upOrDown;
      this.labels = !this.upOrDown ? this.labelData : this.defaultLabels;
    },
    toOrder(val) {
      this.orderActive = val;
      switch (this.orderActive) {
        case 1:
          this.sortViewList = [
            {
              sortLevel: 1,
              sortName: 'sort_code',
              sortStyle: 'ASC',
            },
          ];
          break;
        case 2:
          this.sortViewList = [
            {
              sortLevel: 1,
              sortName: 'sort_code',
              sortStyle: 'DESC',
            },
          ];
          break;
        case 3:
          this.sortViewList = [
            {
              sortLevel: 2,
              sortName: 'up_time',
              sortStyle: 'ASC',
            },
          ];
          break;
        case 4:
          this.sortViewList = [
            {
              sortLevel: 2,
              sortName: 'up_time',
              sortStyle: 'DESC',
            },
          ];
          break;
        case 5:
          this.sortViewList = [
            {
              sortLevel: 0,
              sortName: 'view_count',
              sortStyle: 'ASC',
            },
          ];
          break;
        case 6:
          this.sortViewList = [
            {
              sortLevel: 0,
              sortName: 'view_count',
              sortStyle: 'DESC',
            },
          ];
          break;
      }
      this.getData();
    },

    getCourseType() {
      let user = JSON.parse(localStorage.getItem('userInfo')) == null ? {} : JSON.parse(localStorage.getItem('userInfo'));
      this.typeData = {};
      this.$api.getCourseType().then(res => {
        if (res.success) {
          for(let key in res.data){
            if(!user.uId || user.uId != 3493){
              if(key!='nlp_gongan'){
                this.typeData[key]=res.data[key];
              }
            }else{
              this.typeData[key]=res.data[key];
            }
          }
        }
      });
    },
    getLabels() {
      this.$api.leafLabelNode().then(res => {
        if (res.success) {
          this.labelData = res.data;
          this.defaultLabels = res.data.filter((item, index) => index < 8);
          this.labels = this.defaultLabels;
        }
      });
    },
    handleLabelChange(val) {
      this.getData();
    },
    handleTypeChange(val) {
      this.getData();
    },
    getData() {
      let param = {
        courseTypes: !this.optionType ? [] : [this.optionType],
        limit: this.pageSize,
        page: this.pageNum,
        relevantTags: !this.optionLabel ? [] : [this.optionLabel],
        sortViewList: this.sortViewList,
      };
      this.$api.getcourseList(param, {type: 'json'}).then(res => {
        if (res.success) {
          this.dataList = res.data;
          this.total = res.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    //页码点击事件
    handleSizeChange(val) {
      this.pageNum = val;
      this.getData();
    },
    //分页点击事件
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
@import '../../../assets/less/common.less';
/deep/ .el-radio-button--small .el-radio-button__inner {
  padding: 6px 0px;
  border-radius: 12px;
  margin-right: 10px;
  width: 100px;
}
/deep/ .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 12px;
}
/deep/ .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 12px !important;
}
/deep/ .el-radio-button,
.el-radio-button__inner {
  margin-bottom: 10px;
}
.color-blue {
  color: @nice-blue;
}
/deep/ .el-radio-button__inner{
     border-left:1px solid #dcdfe6!important;
 }
/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
   border-left:none!important;
}
.bread-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  margin-bottom: -20px;
}
section {
  margin-bottom: 60px !important;
  width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
  box-sizing: border-box;
  .search-wrapper {
    box-sizing: border-box;
    padding: 0 20px;
    .search-label {
      line-height: 30px;
      width: 60px;
      color: #666;
    }
    .line {
      margin: 10px 0;
      border-bottom: 1px dashed #d8dee3;
    }
    .course-filter {
      .cell {
        margin-right: 40px;
        cursor: pointer;
        .caret-wrapper {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          height: 34px;
          width: 24px;
          vertical-align: middle;
          cursor: pointer;
          overflow: initial;
          position: relative;
        }
        .sort-caret.ascending {
          border-bottom-color: #c0c4cc;
          top: 5px;
          &.active {
            border-bottom-color: #ff622b;
          }
        }

        .sort-caret {
          width: 0;
          height: 0;
          border: 5px solid transparent;
          position: absolute;
          left: 7px;
        }
        .sort-caret.descending {
          border-top-color: #c0c4cc;
          bottom: 7px;
          &.active {
            border-top-color: #ff622b;
          }
        }
        .sort-caret.descending {
          bottom: 7px;
        }
        &.active{
          color: #ff622b;
        }
      }
    }

    .course-label {
      position: relative;
      .btn-more {
        position: absolute;
        top: 8px;
        right: 0;
        cursor: pointer;
        color: #6366f1;

        i.iconfont {
          font-size: 12px;
        }
      }
    }
  }
  .course-list {
    .course-item {
      width: 300px;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 4px;
      overflow: hidden;
      .img-box {
        height: 200px;
        margin-bottom: 10px;
        border-radius: 4px;
        background:#b7b7b7;
        .img {
          width: 100%;
          height: 200px;
          display: block;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          background-size: cover;
             border-radius: 4px;
        }
      }
      p {
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        i.iconfont {
          margin-right: 15px;
          color: #b9b9b9;
          font-size: 16px;
        }
      }
      p:hover {
        color: @nice-blue;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/nlpCircle/course/index.vue